import { BeltSyllabus } from './types';

export const blackBelt2nd: BeltSyllabus = {
    id: 'black-2nd',
    name: '2nd Degree Black Belt',
    color: '#000000',
    theoryUnder13: [],
    theoryOver13: [
        {
            title: 'Theory',
            subTitle: 'Those going for 3rd degree should learn everything from previous degrees plus',
            items: [
                {
                    question: 'Endeavour to learn any additional stances/techniques, also the terminology for all the new movements in the 3rd degree patterns, as well as their applications',
                    answer: ' '
                },
                { question: 'Specific dates in TKD history', answer: ' ' }
            ]
        },
        {
            title: 'Theory Resources',
            items: [
                { question: 'The Vision TKD Association Black Book or AETA White Book', answer: ' ' },
                { question: 'Path to Black Belt', answer: ' ' },
                { question: 'Condensed Encyclopaedia 1999 version', answer: ' ' },
                { question: 'ITF International Taekwon-Do Federation', answer: 'https://itftkd.sport/' },
                { question: 'ITF England', answer: 'https://www.itfengland.com/' }
            ]
        }
    ],
    practical: [
        {
            title: 'Kicking Combinations (12%)',
            subTitle: '*FS = Fixed Stance, LS = L Stance',
            items: [
                { question: 'Front leg Middle Turning Kick, Rear leg High Reverse Hooking Kick, Side Kick (Consecutive)', answer: ' ' },
                { question: 'Rear leg Sweeping Kick, land *FS U-Shape Block, Jump 360 Spin *LS KH Guarding Block, Front leg Side Kick (hands in KHGB) *LS', answer: ' ' },
                { question: 'Front leg Middle Hooking Kick, Rear leg Middle Twisting Kick', answer: ' ' },
                { question: '(2 Steps) Two Directional Kick land *LS Forearm Guarding Block', answer: ' ' },
                { question: '(1 Step) 360 Reverse Turning Kick', answer: ' ' },
                { question: 'Front leg Pressing Kick, Middle Side Kick, High Side Kick (consecutive), land slow High Reverse Turning Kick', answer: ' ' }
            ]
        },
        {
            title: 'Patterns (37%)',
            subTitle: 'Eui-Am, Choong-Jang, Juche + 3 Designated',
            items: [
                { question: 'Eui-Am', answer: '8%' },
                { question: 'Choong-Jang', answer: '8%' },
                { question: 'Juche', answer: '9%' },
                { question: 'Designated Patterns', answer: '4% each' }
            ]
        },
        {
            title: 'Free Sparring Self-Defence (10%)',
            subTitle: 'With mouth guards & groin guards',
            items: [
                {
                    question: 'Self-defence from minimum two attackers one after the other (avoiding multiple attacks from any grabbing or holding, kicks and swinging punches)',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Sparring (17%)',
            items: [
                { question: '3 Step Sparring', answer: ' ' },
                { question: '2 Step Sparring', answer: ' ' },
                { question: '1 Step Sparring', answer: ' ' },
                { question: '1 Step Foot Sparring', answer: ' ' },
                { question: 'Competition Sparring (with sparring equipment)', answer: ' ' },
                { question: '2 V 1 Sparring (with sparring equipment)', answer: ' ' }
            ]
        },
        {
            title: 'Special Technique (6%)',
            subTitle: [
                'Candidate chooses the height',
                'Performed on Spec Tech Holder',
                '3 Attempts'
            ],
            items: [
                { question: 'Flying Twisting Kick', answer: ' ' },
                { question: '360 Reverse Turning Kick', answer: ' ' }
            ]
        },
        {
            title: 'Special Technique (3%)',
            subTitle: [
                'Choose 1 out of 4 Techniques',
                'Performed on Targets',
                '3 Attempts',
                'Demonstrate Power, Accuracy, Agility'
            ],
            items: [
                { question: 'Two Directional Kick, Punch', answer: ' ' },
                { question: 'Two Directional Kick, Turning Kick', answer: ' ' },
                { question: 'Side Kick, Turning Kick, Punch', answer: ' ' },
                { question: 'Triple Flying Front Kick (Ball of the Foot)', answer: ' ' }
            ]
        },
        {
            title: 'Power Test (3%)',
            subTitle: [
                'Minimum 1 White Board for 16yrs+',
                'Minimum 1 Cream Board for Females/15yrs-',
                'Select more boards to receive a higher %',
                '3 Attempts'
            ],
            headerBackgroundColor: '#d6eaf8',
            items: [
                { question: 'Mid Air Kick from a Parallel Stance (one and a half shoulder width away from the breaking machine)', answer: ' ' }
            ]
        },
        {
            title: 'Power Test - Hand (6%)',
            subTitle: [
                '1 Wooden Board 18mm for 16yrs+',
                '1 Wooden Board 12mm for Female/15yrs-',
                '3 Attempts'
            ],
            headerBackgroundColor: '#d6eaf8',
            items: [
                { question: 'Air Break Punch or Knifehand', answer: ' ' },
                { question: 'Reverse Knifehand', answer: ' ' }
            ]
        },
        {
            title: 'Power Test - Foot (6%)',
            subTitle: [
                'Choose 1 out of 2 Techniques',
                'Minimum 2 White Boards for 16yrs+',
                'Minimum 2 Cream Boards for Female/15yrs-',
                'Select more boards for a higher %',
                '3 Attempts'
            ],
            headerBackgroundColor: '#d6eaf8',
            items: [
                { question: 'Turning Kick', answer: ' ' },
                { question: 'Reverse Turning Kick', answer: ' ' }
            ]
        },
        {
            title: 'Theory',
            items: [
                { question: 'Theory Paper - must get 60% before the practical exam', answer: ' ' }
            ]
        }
    ]
};
